
import Vue from 'vue'
// 注册VueI18n
import VueI18n from 'vue-i18n'
Vue.use(VueI18n);
// 引入VueI18n
import TC from './langs/tc.js'
import ZH from './langs/zh.js'
/**
 * 格式化 window.location.pathname
 * @param {*} pathUrl
 */
function resolvePathName(pathUrl) {
  // browsers replaceAll 存在限制
  // return (pathUrl + '').replaceAll(''"', '')
  return (pathUrl + '').replace(/\//g, '')
}
console.log(window.location)
let locale = '';
if(['www.tintinhealth.cn','tintinhealth.cn'].includes(resolvePathName(location.hostname))) {
    document.title = ZH.common.company;
    locale = 'zh';
}
if(['www.tintintechnology.cn','tintintechnology.cn'].includes(resolvePathName(location.hostname))) {
    document.title = TC.common.company;
    locale = 'tc';
}
const i18n = new VueI18n({
    // locale: localStorage.getItem('languageStorage') || 'zh',
    locale: locale || 'zh',
    messages: {
        zh: ZH,
        tc: TC,
    },
});
export default i18n



// WEBPACK FOOTER //
// ./src/i18n/i18n.js